import { render, staticRenderFns } from "./BookingOrderDetails.vue?vue&type=template&id=50014d96&scoped=true"
import script from "./BookingOrderDetails.vue?vue&type=script&lang=js"
export * from "./BookingOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingOrderDetails.vue?vue&type=style&index=0&id=50014d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50014d96",
  null
  
)

export default component.exports